import { useState } from "react";
import { createUseStyles } from "react-jss";
import produce from "immer";
import RedButton from "../../refresh/RedButton";
import SidebarLightbox from "../../refresh/SidebarLightbox";
import styles from "./sharedStyles";
import TextInput from "../../refresh/inputs/TextInput";
import Checkbox from "../../refresh/inputs/Checkbox";
import Label from "../../refresh/Label";

const useStyles = createUseStyles({
  ...styles,
});

const EditLookAtHotspot = ({
  show,
  hotspot,
  onClose,
  onComplete,
  incomingScenes,
}) => {
  const classes = useStyles();
  const [config, setConfig] = useState(
    produce(hotspot, draft => {
      draft.options.onEnter = true;
      draft.options.activeDirections ??= null;
      draft.options.showEyeIcon ??= false;
      draft.options.onlyStartingImage ??= false;
    }),
  );

  return (
    <SidebarLightbox
      show={show}
      onClose={onClose}
      sidebar={
        <>
          <h1 className={classes.title}>Edit Look At Hotspot</h1>
          <p className={classes.subtitle}>
            This rotates the camera to face the direction of the hotspot when
            entering a scene. In tours, the icon is hidden.
          </p>
          <p className={classes.subtitle}>
            Note: Only one should be added per scene.
          </p>
          <div className={classes.grow} />
        </>
      }
    >
      <div className={classes.options}>
        <h1>Options</h1>
        <TextInput
          label="tooltip"
          required
          value={config.tooltip}
          onChange={tooltip =>
            setConfig(
              produce(c => {
                c.tooltip = tooltip;
              }),
            )
          }
        />
        <TextInput
          label="Rotation text"
          required
          value={config.options.name}
          onChange={name =>
            setConfig(
              produce(c => {
                c.options.name = name;
              }),
            )
          }
        />
        <Checkbox
          value={config.options.activeDirections !== null}
          onChange={enable =>
            setConfig(
              produce(draft => {
                draft.options.activeDirections = enable ? [] : null;
                if (enable) {
                  draft.options.onlyStartingImage = false;
                }
              }),
            )
          }
        >
          Only enable for specific entry directions (currently:{" "}
          {config.options.activeDirections !== null
            ? "specific directions"
            : "all directions"}
          )
        </Checkbox>
        <Checkbox
          value={config.options.showEyeIcon}
          onChange={enable =>
            setConfig(
              produce(draft => {
                draft.options.showEyeIcon = enable;
              }),
            )
          }
        >
          Show eye icon
        </Checkbox>
        <Checkbox
          value={config.options.onlyStartingImage}
          onChange={enable =>
            setConfig(
              produce(draft => {
                draft.options.onlyStartingImage = enable;
                if (enable) {
                  draft.options.activeDirections = null;
                }
              }),
            )
          }
        >
          Only enable for starting image
        </Checkbox>
        {config.options.activeDirections !== null && (
          <Label name="Entry directions">
            {incomingScenes.map(scene => (
              <Checkbox
                value={config.options.activeDirections.includes(scene.id)}
                onChange={enable =>
                  setConfig(
                    produce(draft => {
                      if (enable) {
                        draft.options.activeDirections.push(scene.id);
                      } else {
                        draft.options.activeDirections =
                          draft.options.activeDirections.filter(
                            x => x !== scene.id,
                          );
                      }
                    }),
                  )
                }
              >
                {scene.name}
              </Checkbox>
            ))}
          </Label>
        )}
        <RedButton
          disabled={!(config.tooltip && config.options?.name)}
          onClick={() => onComplete(config)}
        >
          Save
        </RedButton>
      </div>
    </SidebarLightbox>
  );
};

export default EditLookAtHotspot;
